import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import AttendantsMain from "../../components/attendants/AttendantsMain";
import Footer from "../../components/common/Footer";

export default function AttendantPage() {
  return (
    <>
      <TitleBar />
      <NavMenu />
      <AttendantsMain />
      <Footer />
    </>
  );
}
